import { PlayerProfileDay } from '../../../core/models/player-profile';

export function profileChart(history: PlayerProfileDay[]) {
  const days = [...history].sort((a, b) => a.annualMatchdayNumber - b.annualMatchdayNumber);
  const low = Math.min(0, ...days.map(d => d.points ?? 0));
  const high = Math.max(1, ...days.map(d => d.points ?? 0));
  const valueMax = Math.max(1, ...days.map(d => d.marketValue ?? 0));
  const y = (points: number) => 220 - (points - low) / (high - low) * 180;
  const zero = y(0);
  const step = 560 / Math.max(1, days.length);
  const bars = days.map((day, i) => {
    const x = 60 + step * (i + 0.5);
    const pointY = day.points === null ? zero : y(day.points);
    return { ...day, x, y: Math.min(zero, pointY), height: Math.abs(zero - pointY),
      width: Math.min(24, step * 0.6), valueY: day.marketValue === null ? null : 220 - day.marketValue / valueMax * 180 };
  });
  const paths: string[] = [];
  let segment = '';
  for (const day of bars) {
    if (day.valueY === null) {
      if (segment) paths.push(segment);
      segment = '';
    } else {
      segment += `${segment ? ' L' : 'M'}${day.x},${day.valueY}`;
    }
  }
  if (segment) paths.push(segment);
  return { bars, paths, zero, low, high, valueMax };
}
